import { useQuery } from '@tanstack/react-query';

import tassAxios from '@/apis/tass-api/axios';

import { OrganizationResponse } from '../types';

const getOrganizationById = async (organizationId: string): Promise<OrganizationResponse> => {
  const { data } = await tassAxios.get('/api/Organization/GetById', {
    params: { organizationId },
  });
  return data;
};

export const useGetOrganizationById = (organizationId: string) => {
  return useQuery<OrganizationResponse>({
    queryKey: ['organization', organizationId],
    queryFn: () => getOrganizationById(organizationId),
    enabled: !!organizationId,
    refetchOnWindowFocus: false,
  });
};
